import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { Ejecutivo } from 'src/app/global/interfaces/ejecutivo';
import { MarketplaceParameter } from 'src/app/global/interfaces/marketplace-parameter';
import { Paso1Login } from 'src/app/global/interfaces/paso-1-login';
import { DatosSociosService } from 'src/app/global/services/datos-socios.service';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-persona-juridica-login',
  templateUrl: './persona-juridica-login.component.html',
  styleUrls: ['./persona-juridica-login.component.scss']
})
export class PersonaJuridicaLoginComponent implements OnInit {

  loading = false;
  processing = false;
  isPersonaNatural = false;
  isMobile = null;
  product: Product;
  @Input() isRetoma: boolean;
  utm? = "";
  urlTerminos = environment.redirections.urlTerminos;
  urlPrivacidad = environment.redirections.urlPrivacidad;
  ejecutivo: Ejecutivo;
  clickTimeout = null;
  public mensajeErrorDatosEmpresa = step1Messages;

  @Output() nextStep: EventEmitter<any> = new EventEmitter();

  dataPersonaJuridica: FormGroup = null;
  constructor(
    private authVmService: AuthVMService,
    private storage: LocalStorageService,
    private carroService: CarroComprasService,
    private tagM: TagManagerService,
    private dialogService: DialogService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private inputErrorService: InputErrorService,
    private carroServ: CarroComprasService,
    private datosSociosService: DatosSociosService,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) { }

  public messageRescatarDataError = {
    txtRut: [
      { type: 'dniInvalid', message: step1Messages.INVALID_RUT_MESSAGE },
      { type: 'required', message: step1Messages.REQUIRED_RUT_MESSAGE }
    ],
    txtEmail: [
      { type: 'emailInvalid', message: step1Messages.REQUIRED_EMAIL_MESSAGE },
      { type: 'required', message: step1Messages.REQUIRED_EMAIL_MESSAGE }
    ]
  };

  ngOnInit() {
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.authVmService.initCaptcha();
    this.dataPersonaJuridica = this.authVmService.createLoginForm();
    this.getSelectedProduct();
    this.getEjecutivoData();
    this.utm = this.route.snapshot.queryParams.utm;
    this.dataPersonaJuridica.patchValue({
      isMarketplaceSVA: String(this.route.snapshot.queryParams.msva).toLowerCase() === 'true'
    });

  }

  getSelectedProduct() {
    const parameters: MarketplaceParameter = this.carroServ.loadFromUrl();
    if (parameters) {
      parameters.productos.every((prod) => {
        this.dataPersonaJuridica.patchValue({
          txtProducto: prod.codigoProducto
        });
      });
    }
  }

  getEjecutivoData() {
    this.ejecutivo = this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo : this.sessionService.getEjecutivo();
    if(this.ejecutivo){
      if(this.sessionService.ejecutivo != null){
        this.dataPersonaJuridica.patchValue({
          txtEjecutivo: this.sessionService.ejecutivo.id
        });
      }
    }
  }

  get rutControl(): FormControl {
    return this.dataPersonaJuridica.get('txtRut') as FormControl;
  }

  get correoControl(): FormControl {
    return this.dataPersonaJuridica.get('txtCorreo') as FormControl;
  }

  get telefonoControl(): FormControl {
    return this.dataPersonaJuridica.get('txtTelefono') as FormControl;
  }

  get productoControl(): FormControl {
    return this.dataPersonaJuridica.get('txtProducto') as FormControl;
  }

  get authControl(): FormControl {
    return this.dataPersonaJuridica.get('autorizacion') as FormControl;
  }

  get authControl2(): FormControl {
    return this.dataPersonaJuridica.get('autorizacion2') as FormControl;
  }

  get ejecutivoControl(): FormControl {
    return this.dataPersonaJuridica.get('txtEjecutivo') as FormControl;
  }

  async onSubmit(): Promise<void> {
    let authResponse = null;
    try {
      this.loading = true;
      this.saveStep1();

      this.dataPersonaJuridica.patchValue({
        txtEjecutivo: this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo.id : null
      });

      authResponse = await this.authVmService.authLogin(this.dataPersonaJuridica, this.isMobile);


      if (_.get(authResponse, 'indicador', '') === 'BLOQUEO_EMPRESA_UN_DIA') {
        this.dataPersonaJuridica.get('txtRut').reset();
        this.dataPersonaJuridica.get('txtCorreo').reset();
        this.dataPersonaJuridica.get('txtTelefono').reset();
        this.dataPersonaJuridica.get('autorizacion').reset();
        this.dataPersonaJuridica.get('autorizacion2').reset();
      } else {
        if (_.get(authResponse, 'indicador', '') === 'OK') {
          this.processing = false;
          this.save(authResponse);
          this.tagM.logDL_completa_datos();
        }
      }
    } catch (exception) {
      this.tagM.logError('Paso 1', _.get(exception, 'error.mensaje.titulo', ''), _.get(exception, 'error.message', ''));
      let respuesta: any;
      if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'se le han agotado los intentos')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
      } else if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'Los datos no son correctos para el login')) {
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Alguno de los datos ingresados no coinciden.<br>Por favor, intenta nuevamente.');
      } else if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'Debe ingresar un producto valido')) {
        respuesta = this.dialogService.openContratacionNoIniciada();
      } else {
        console.error(exception);
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
      }
      respuesta.afterClosed().subscribe((resp) => {
        if (resp.action === 'OK') {
          return;
        }
      });
    } finally {
      this.loading = false;
      this.processing = false;
    }
  }

  Continuar($event: any) {
    $event.stopPropagation();
    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.onSubmit();
      }, 100);
    }
  }

  save(serviceResponse?: any) {
    const paso_1: Paso1Login = {
      run: this.rutControl.value,
      telefono: this.telefonoControl.value,
      correo: this.correoControl.value,
      producto: this.productoControl.value,
      retoma: serviceResponse != null ? _.get(serviceResponse, 'mensaje.contenido', '') : AUTH_INDICATOR.EMPTY_STRING,
      currentIsPersonaNatural: this.isPersonaNatural,
      ejecutivo: this.ejecutivoControl.value === "" ? null : this.ejecutivoControl.value,
      utm: this.utm
    };

    this.storage.setPaso1Login(paso_1);
    this.storage.setCurrentPage(_.get(environment, 'localStorage.PASO_2', ''));
    this.carroService.changePaso('P_1');
  }

  saveStep1() {
    const paso_1: Paso1Login = {
      run: this.rutControl.value,
      telefono: this.telefonoControl.value,
      correo: this.correoControl.value,
      producto: this.productoControl.value,
      retoma: null,
      ejecutivo: this.ejecutivoControl.value === "" ? null : this.ejecutivoControl.value,
      currentIsPersonaNatural: this.isPersonaNatural,
      utm: this.utm
    };
    this.storage.setPaso1Login(paso_1);
  }

  checkInput(campo: string) {
    this.inputErrorService.validarError('P1', this.dataPersonaJuridica.get(campo));
  }

}
